export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const SET_TOPBAR_THEME = 'SET_TOPBAR_THEME';
export const OPEN_SIGN_IN_MODAL = 'OPEN_SIGN_IN_MODAL';
export const OPEN_FORGOT_PASSWORD_MODAL = 'OPEN_FORGOT_PASSWORD_MODAL';
export const SET_BASIC_USER_DETAILS = 'SET_BASIC_USER_DETAILS';
export const SET_INITIAL_PROGRAM_DATA = 'SET_INITIAL_PROGRAM_DATA';
export const SET_INITIAL_MODULE_DATA = 'SET_INITIAL_MODULE_DATA';
export const SET_CONTINUE_LEARNING_DATA = 'SET_CONTINUE_LEARNING_DATA';
export const SET_ONGOING_PROGRAM_DATA = 'SET_ONGOING_PROGRAM_DATA';
export const SET_ENROLLED_PROGRAMS_DATA = 'SET_ENROLLED_PROGRAMS_DATA';
export const SET_ACTIVE_PROGRAM_ID = 'SET_ACTIVE_PROGRAM_ID';
export const SET_ACTIVE_MODULE_ID = 'SET_ACTIVE_MODULE_ID';
export const SET_UNREAD_NOTIF_COUNT = 'SET_UNREAD_NOTIF_COUNT';
export const SETUP_PROGRAM_DETAILS_TOPBAR = 'SETUP_PROGRAM_DETAILS_TOPBAR';
export const SHOW_QUIZ_NAVBAR = 'SHOW_QUIZ_NAVBAR';
export const ON_PROFILE_PIC_UPDATED = 'ON_PROFILE_PIC_UPDATED';
export const SET_TOPBAR_STRIP_STATUS = 'SET_TOPBAR_STRIP_STATUS';

export const ON_FAILURE_DIALOG_SHOW = 'ON_FAILURE_DIALOG_SHOW';
export const ON_FAILURE_DIALOG_HIDE = 'ON_FAILURE_DIALOG_HIDE';
export const ON_SUCCESS_DIALOG_SHOW = 'ON_SUCCESS_DIALOG_SHOW';
export const ON_SUCCESS_DIALOG_HIDE = 'ON_SUCCESS_DIALOG_HIDE';
export const REDIRECT_TO_UNAUTHORIZED = 'REDIRECT_TO_UNAUTHORIZED';
export const REDIRECT_TO_NOT_FOUND = 'REDIRECT_TO_NOT_FOUND';
export const REDIRECT_TO_SERVER_ERROR = 'REDIRECT_TO_SERVER_ERROR';
export const RESET_ALL_ERROR_PAGES = 'RESET_ALL_ERROR_PAGES';
export const UPDATE_LEARNER_LIVE_SESSION_STATUS = 'UPDATE_LEARNER_LIVE_SESSION_STATUS';
export const SHOW_SESSION_EXPIRED_DIALOG = 'SHOW_SESSION_EXPIRED_DIALOG';
export const REDIRECT_TO_HOME = 'REDIRECT_TO_HOME';